import { CustomerSupportDetailsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

const useCustomerSupportDetails = () => {
  const { data, loading } = useQuery(CustomerSupportDetailsDocument, {})

  const customerSupportDetail = data?.public.customerSupportDetailsConnection.nodes[0]

  return {
    loading,
    customCustomerContactUrl: customerSupportDetail?.customCustomerContactUrl,
    customCustomerSupportUrl: customerSupportDetail?.customCustomerSupportUrl,
    customPrivacyPolicyUrl: customerSupportDetail?.customPrivacyPolicyUrl,
  }
}

export default useCustomerSupportDetails
